export const DEFAULT_PHONE_NUMBER = '+47';